import type { IPerson } from "../interfaces/models/IPerson";
import EventBus, { EventBusValues } from "./EventBus";
import {
  createProfilePhotoTimestamp,
  parseProfilePhotoTimestamp,
  setProfilePhotoCacheBust,
} from "./profilePictureUrl";

export const PROFILE_PHOTO_UPDATED_EVENT = "ProfilePhotoUpdated";

/** Bust CDN cache + notify listeners after any person's profile photo changes. */
export function notifyProfilePhotoCacheBust(
  personId: string,
  cacheBust?: number,
): void {
  const id = personId?.trim();
  if (!id) {
    return;
  }

  const ts = cacheBust ?? Date.now();
  setProfilePhotoCacheBust(id, ts);
  document.dispatchEvent(
    new CustomEvent(PROFILE_PHOTO_UPDATED_EVENT, {
      detail: { personId: id, cacheBust: ts },
    }),
  );
}

/** Refresh header/session state after the logged-in user's profile photo changes. */
export function notifyProfilePhotoUpdated(person: IPerson): void {
  const personId = person.id?.trim();
  if (!personId) {
    return;
  }

  const photoTimestamp =
    parseProfilePhotoTimestamp(person.photo) ??
    Number(createProfilePhotoTimestamp());

  notifyProfilePhotoCacheBust(personId, photoTimestamp);
  EventBus.dispatch(EventBusValues.UpdateLoggedPerson, {
    ...person,
    photo: String(photoTimestamp),
  });

  window.postMessage({ type: "imageUpdated" }, "*");
}
